import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/empty.vue").then(m => m.default || m)),
  "lithium-overview": defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/lithium/overview.vue").then(m => m.default || m)),
  "lithium-supply": defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/lithium/supply.vue").then(m => m.default || m))
}